import { default as ApiConstants } from 'shared/constants/ApiConstants.json';
import ApiUtils from 'shared/modules/ApiUtils';

const getDestinationsAPI = (payload) =>
    ApiUtils.getRequest(`${ApiConstants.DESTINATION_ENDPOINT}/${payload.buyerId}`);

export { getDestinationsAPI };
